export const SOCIAL_LINKS = {
  facebook: 'https://www.facebook.com/MinNyeElbil/',
  instagram: 'https://www.instagram.com/minnyeelbil/',
  youtube: 'https://www.youtube.com/@minnyeelbil',
} as const;

export type SocialChannel = keyof typeof SOCIAL_LINKS;

/**
 * Bygger en URL med UTM-parametre, så klik kan måles i analytics.
 * placement = hvor på sitet linket vises (fx "footer", "home-strip", "newsletter-success").
 */
export function buildSocialUrl(channel: SocialChannel, placement: string): string {
  const base = SOCIAL_LINKS[channel];
  try {
    const u = new URL(base);
    u.searchParams.set('utm_source', 'minnyeelbil');
    u.searchParams.set('utm_medium', 'social_follow');
    u.searchParams.set('utm_campaign', `follow_${channel}`);
    u.searchParams.set('utm_content', placement);
    return u.toString();
  } catch {
    return base;
  }
}
